import React from 'react';
import PropTypes from 'prop-types';
import SocialShare from 'widget/player-widget/components/social-share/social-share';
import { openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

import styles from './popup-content.styl';

export default class ShareMobileContent extends React.Component {

  static propTypes = {
    inputLabel: PropTypes.string.isRequired,
    shareParams: PropTypes.object,
    onShare: PropTypes.func,
  };

  render() {
    const { shareParams, onShare, inputLabel } = this.props;

    return (
      <div>
        <input type="text"
               aria-label={inputLabel}
               className={styles['url-input']}
               value={shareParams.siteUrl}
               readOnly />
        <SocialShare networks={['facebook', 'twitter', 'pinterest', 'tumblr']}
                     className={styles['share-container']}
                     buttonClassName={styles['share-button']}
                     content={shareParams}
                     onShare={onShare}
                     openPreviewPrompt={openPreviewPrompt} />
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/mobile/components/share-mobile/popup-content/popup-content.js